import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { takeUntil } from 'rxjs/operators';
import { DataTableRequest } from 'src/app/models/datatable-request';
import { User } from 'src/app/models/user';
import { DialogData } from '../../models/dialog-data';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { ApplicationService } from '../../services/application.service';
import { UserService } from '../../services/user/user.service';
import { TokenStorageService } from '../../services/token-storage/token-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { MatTable } from '@angular/material/table';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { FormControl } from '@angular/forms';
import { HakCutiDialogComponent } from 'src/app/hak-cuti-dialog/hak-cuti-dialog.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit, OnDestroy {
  @ViewChild('paginator') paginator: MatPaginator | undefined;
  dataSource: User[] = [];
  displayedColumns: string[] = [
    'username',
    'name',
    'role',
    'substansi',
    'atasan',
    'pejabat',
    'status',
    'action',
  ];
  page = 0;
  searchTerm = '';
  length = 0;
  pageSize = 20;
  pageSizeOptions: number[] = [20, 50, 100];
  pageEvent: PageEvent | undefined;

  @ViewChild(MatTable)
  table!: MatTable<User>;
  isLoading = false;
  onDestroy$ = new Subject<void>();

  isUploading = false;
  uploadFileForm = new FormControl();

  constructor(
    public dialog: MatDialog,
    public tokenStorageService: TokenStorageService,
    private userService: UserService,
    private applicationService: ApplicationService,
  ) { }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnInit(): void {
    this.reload();

    this.applicationService.unlockScreen$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.reload();
      });
  }

  search() {
    this.page = 0;
    this.paginator?.firstPage();
    this.length = 0;
    this.reload();
  }

  reload(event?: PageEvent) {
    const payload: DataTableRequest = {
      page: event ? event.pageIndex : this.page,
      dataPerPage: event ? event.pageSize : this.pageSize,
      searchTerm: this.searchTerm,
    };
    this.getUserList(payload);
  }

  openDialog(user?: User) {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      data: user,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.reload();
      }
    });
  }

  openHakCutiDialog(user: User) {
    const dialogRef = this.dialog.open(HakCutiDialogComponent, {
      data: user,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.reload();
      }
    });
  }

  openHierarchyDialog(user?: User) {
    // const dialogRef = this.dialog.open(UserHierarchyComponent, {
    //   data: user,
    //   disableClose: true,
    // });
    // dialogRef.afterClosed().subscribe((result) => { });
  }

  confirmDialog(user: User) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan menghapus data ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isLoading = true;
        this.userService.delete(user).subscribe(() => {
          this.isLoading = false;
          this.reload();
        });
      }
    });
  }

  confirmResetDialog(user: User) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan mereset password user ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.userService.refine().subscribe(() => {
        //   this.reload();
        // });
        this.isLoading = true;
        this.userService.reset(user.id).subscribe(() => {
          this.isLoading = false;
          this.reload();
        });
      }
    });
  }

  confirmActivationDialog(user: User) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message:
          'Apakah Anda yakin akan ' +
          (user.enabled === 1 ? 'Menonaktifkan' : 'Mengaktifkan') +
          ' user ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.userService.refine().subscribe(() => {
        //   this.reload();
        // });
        this.isLoading = true;
        user.enabled = user.enabled === 0 ? 1 : 0;
        this.userService.update(user).subscribe(() => {
          this.isLoading = false;
          this.reload();
        });
      }
    });
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
    }
  }

  displayUserRoles(user: User): string {
    return user.userRoles.map((userRole) => userRole.role?.name).join(', ');
  }

  selectFile(event: any): void {
    if (event.target.files.length > 0) {
      this.isUploading = true;
      this.uploadFileForm = new FormControl();
      this.userService.upload(event.target.files).subscribe(() => {
        this.isUploading = false;
        this.displayInfo('Perubahan data berhasil disimpan');
      });
    }
  }

  selectFile2(event: any): void {
    if (event.target.files.length > 0) {
      this.isUploading = true;
      this.uploadFileForm = new FormControl();
      this.userService.upload2(event.target.files).subscribe(() => {
        this.isUploading = false;
        this.displayInfo('Perubahan data berhasil disimpan');
      });
    }
  }

  displayInfo(message: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Informasi',
        message: message,
        okLabel: 'OK',
        isConfirmation: false,
      },
    });
  }

  private getUserList(payload: DataTableRequest) {
    this.isLoading = true;
    this.userService.getUsers(payload).subscribe((response: { users: User[]; total: number; page: number; }) => {
      this.table.renderRows();
      this.dataSource = response.users;
      this.length = response.total;
      this.page = response.page;
      this.isLoading = false;
    });
  }
}
